import { Card, Table, Space, Typography, Progress } from 'antd';
import React from 'react';
import ColorKey from "../../../../../Components/ColorKey";
import { mapExposureColor, ExposureColors } from "../utils";
import { useEnsureTickersLoaded } from "../../../../../Hooks/useEnsureTickersLoaded";
import TickerChip from "../../../../../Components/TickerChip";

const ExposureTable = ({ maxExposureData, currentWeights }) => {
  // Define the logic to get the color based on the quintile of max exposure
  const { tickers } = useEnsureTickersLoaded(maxExposureData.map(item => item.x.toLowerCase()));
  maxExposureData.sort((a, b) => b.value - a.value);
  console.log('tickers', tickers)

  const columns = [
    {
      title: 'Ticker',
      render: (text, record)=>{
        const ticker = tickers.find(x=>x.symbol===record.x.toLowerCase());
        return ticker ? <TickerChip ticker={ticker} /> : record.x;
      },
      width: 150,
    },
    {
      title: 'Current Weight',
      dataIndex: 'currentExposure',
      key: 'currentExposure',
      render: (text, record) => <Space direction={'vertical'}>
        <span>
          <b>{(currentWeights[record.x.toLowerCase()] * 100).toFixed(1)}%</b> / <i>{record.value}%</i>
        </span>
        <Progress
              size={[100, 10]}
              type={'line'}
              strokeColor={{
                '0%': ExposureColors[0],
                '100%': ExposureColors[ExposureColors.length-1],
              }}
              percent={record.value}
              format={() => ``}
          />
      </Space>,
    },
    // Add other columns as needed
  ];

  const dataWithCurrentExposure = maxExposureData.map(item => ({
    ...item,
    currentExposure: currentWeights[item.x.toLowerCase()] * 100, // assuming currentWeights are fractions
  }));

  return (
        <Table
          dataSource={dataWithCurrentExposure}
          columns={columns}
          rowKey="x"
          scroll={{y: 600, x: 'max-content'}}
        />
  );
};

export default ExposureTable;
